var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g, _circle30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuperGraphics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 919,
    viewBox: "0 0 720 919",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 894.594L49.8585 902.652L32.9566 915.836L30 894.594Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3048 877.195L72.1634 885.254L55.2614 898.438L52.3048 877.195Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6097 859.797L94.4682 867.855L77.5663 881.04L74.6097 859.797Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9146 842.398L116.773 850.457L99.8711 863.641L96.9146 842.398Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.219 825L139.078 833.059L122.176 846.243L119.219 825Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5354 908.219L78.3939 916.278L61.4919 929.462L58.5354 908.219Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8402 890.821L100.699 898.879L83.7968 912.063L80.8402 890.821Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.145 873.422L123.004 881.481L106.102 894.665L103.145 873.422Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.45 856.024L145.308 864.083L128.406 877.267L125.45 856.024Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0707 921.845L106.929 929.903L90.0273 943.087L87.0707 921.845Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.376 904.446L129.234 912.505L112.332 925.689L109.376 904.446Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M131.68 887.048L151.539 895.106L134.637 908.291L131.68 887.048Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.606 935.47L135.465 943.529L118.563 956.713L115.606 935.47Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.911 918.072L157.769 926.13L140.867 939.315L137.911 918.072Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M144.141 949.096L164 957.154L147.098 970.338L144.141 949.096Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 614.52,
    cy: 691.028,
    r: 6.73132,
    transform: "rotate(-45 614.52 691.028)",
    fill: "#FFE10C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 628.781,
    cy: 676.766,
    r: 6.73132,
    transform: "rotate(-45 628.781 676.766)",
    fill: "#FFE10C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 643.043,
    cy: 662.503,
    r: 6.73132,
    transform: "rotate(-45 643.043 662.503)",
    fill: "#FFE10C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 657.309,
    cy: 648.24,
    r: 6.73132,
    transform: "rotate(-45 657.309 648.24)",
    fill: "#FFE10C"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 671.57,
    cy: 633.978,
    r: 6.73132,
    transform: "rotate(-45 671.57 633.978)",
    fill: "#FFE10C"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.832,
    cy: 619.715,
    r: 6.73132,
    transform: "rotate(-45 685.832 619.715)",
    fill: "#FFE10C"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 628.781,
    cy: 705.291,
    r: 6.73132,
    transform: "rotate(-45 628.781 705.291)",
    fill: "#FFE10C"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 643.043,
    cy: 691.028,
    r: 6.73132,
    transform: "rotate(-45 643.043 691.028)",
    fill: "#FFE10C"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 657.305,
    cy: 676.766,
    r: 6.73132,
    transform: "rotate(-45 657.305 676.766)",
    fill: "#FFE10C"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 671.57,
    cy: 662.503,
    r: 6.73132,
    transform: "rotate(-45 671.57 662.503)",
    fill: "#FFE10C"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.832,
    cy: 648.24,
    r: 6.73132,
    transform: "rotate(-45 685.832 648.24)",
    fill: "#FFE10C"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.094,
    cy: 633.978,
    r: 6.73132,
    transform: "rotate(-45 700.094 633.978)",
    fill: "#FFE10C"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 643.043,
    cy: 719.554,
    r: 6.73132,
    transform: "rotate(-45 643.043 719.554)",
    fill: "#FFE10C"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 657.305,
    cy: 705.291,
    r: 6.73132,
    transform: "rotate(-45 657.305 705.291)",
    fill: "#FFE10C"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 671.566,
    cy: 691.028,
    r: 6.73132,
    transform: "rotate(-45 671.566 691.028)",
    fill: "#FFE10C"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.832,
    cy: 676.766,
    r: 6.73132,
    transform: "rotate(-45 685.832 676.766)",
    fill: "#FFE10C"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.094,
    cy: 662.503,
    r: 6.73132,
    transform: "rotate(-45 700.094 662.503)",
    fill: "#FFE10C"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.355,
    cy: 648.24,
    r: 6.73132,
    transform: "rotate(-45 714.355 648.24)",
    fill: "#FFE10C"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 657.309,
    cy: 733.816,
    r: 6.73132,
    transform: "rotate(-45 657.309 733.816)",
    fill: "#FFE10C"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 671.57,
    cy: 719.554,
    r: 6.73132,
    transform: "rotate(-45 671.57 719.554)",
    fill: "#FFE10C"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.832,
    cy: 705.291,
    r: 6.73132,
    transform: "rotate(-45 685.832 705.291)",
    fill: "#FFE10C"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.098,
    cy: 691.028,
    r: 6.73132,
    transform: "rotate(-45 700.098 691.028)",
    fill: "#FFE10C"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.359,
    cy: 676.766,
    r: 6.73132,
    transform: "rotate(-45 714.359 676.766)",
    fill: "#FFE10C"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 728.621,
    cy: 662.503,
    r: 6.73132,
    transform: "rotate(-45 728.621 662.503)",
    fill: "#FFE10C"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 671.57,
    cy: 748.079,
    r: 6.73132,
    transform: "rotate(-45 671.57 748.079)",
    fill: "#FFE10C"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 685.832,
    cy: 733.816,
    r: 6.73132,
    transform: "rotate(-45 685.832 733.816)",
    fill: "#FFE10C"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 700.094,
    cy: 719.554,
    r: 6.73132,
    transform: "rotate(-45 700.094 719.554)",
    fill: "#FFE10C"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 714.359,
    cy: 705.291,
    r: 6.73132,
    transform: "rotate(-45 714.359 705.291)",
    fill: "#FFE10C"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 728.621,
    cy: 691.028,
    r: 6.73132,
    transform: "rotate(-45 728.621 691.028)",
    fill: "#FFE10C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4695_763",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -40,
    y: 0,
    width: 279,
    height: 282
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -39.0625,
    y: 118.555,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 -39.0625 118.555)",
    fill: "#15A0DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -26.0508,
    y: 107.264,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 -26.0508 107.264)",
    fill: "#15A0DC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -13.0352,
    y: 95.9735,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 -13.0352 95.9735)",
    fill: "#15A0DC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -0.0234375,
    y: 84.6825,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 -0.0234375 84.6825)",
    fill: "#15A0DC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9922,
    y: 73.3915,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 12.9922 73.3915)",
    fill: "#15A0DC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.0039,
    y: 62.1005,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 26.0039 62.1005)",
    fill: "#15A0DC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 39.0195,
    y: 50.8095,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 39.0195 50.8095)",
    fill: "#15A0DC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 52.0312,
    y: 39.5185,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 52.0312 39.5185)",
    fill: "#15A0DC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 65.0469,
    y: 28.2275,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 65.0469 28.2275)",
    fill: "#15A0DC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 78.0586,
    y: 16.9365,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 78.0586 16.9365)",
    fill: "#15A0DC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 91.0742,
    y: 5.64554,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 91.0742 5.64554)",
    fill: "#15A0DC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4695_763)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96.6204,
    cy: 136.754,
    r: 87.222,
    fill: "#34B5EC"
  }))), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.6048,
    cy: 109.994,
    r: 87.222,
    fill: "#34B5EC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperGraphics);
export default __webpack_public_path__ + "static/media/super-graphics.24e0d8ec684952bb0897b15b83266563.svg";
export { ForwardRef as ReactComponent };